import {IComponentOptions} from 'angular';
import {MigrationRS} from '../../service/MigrationRS.rest';

require('./migrationView.scss');
let template = require('./migrationView.html');

export class MigrationViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    bindings: any = {};
    template: string = template;
    controller: any = MigrationViewController;
    controllerAs: string = 'vm';
}

export class MigrationViewController {
    static $inject = ['MigrationRS'];

    personId: string;
    schadenId: string;

    /* @ngInject */
    constructor(private migrationRS: MigrationRS) {
    }

    $onInit() {
    }

    public importschadenfaelle() {
        this.migrationRS.importSchadenfaelle();

    }

    public importGemeinden() {
        this.migrationRS.importGemeinden();
    }

    public importPersonen() {
        this.migrationRS.importPersonen();

    }

    public importGesuchsteller() {
        this.migrationRS.importGesuchsteller(this.personId);

    }

    public importBeitragForSchaden() {
        this.migrationRS.importBeitragForSchadenfall(this.schadenId);

    }

}



// WEBPACK FOOTER //
// ./src/app/admin/component/migrationView/migrationView.ts